import { Components, customHooks } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";

import { useAppSelector } from "../../../../../redux";
import Menu from "./Menu";
import { Container } from "./style";

export const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { profile_picture } = useAppSelector((state) => state.me);
  customHooks.useClickOutside({ ref: dropdownRef, setState: setIsOpen });

  return (
    <Container ref={dropdownRef}>
      <Components.Avatar
        type="Circle"
        size="Small-40"
        disabled={false}
        src={profile_picture}
        onClick={() => setIsOpen((prev) => !prev)}
      />
      {isOpen && <Menu isOpen={isOpen} setIsOpen={setIsOpen} />}
    </Container>
  );
};
